import { j as g } from "./jsx-runtime-3tyXYecC.mjs";
import { f as M } from "./index-LyFokDcn.mjs";
import { useState as T, useEffect as p, useCallback as eo, forwardRef as io, useContext as mo, useRef as lo, useImperativeHandle as so } from "react";
import { C as no } from "./currency-picker-provider-CTRNrW3S.mjs";
import { u as ao } from "./use-readable-context-BO-ExsvT.mjs";
import { C as bo } from "./currency-picker-BHeMYSQ_.mjs";
import { m as yo } from "./tss-DN0acMKN.mjs";
import { S as co, C as ro } from "./controlled-amount-input-BlMZCnzi.mjs";
const to = (e, o) => {
  const [s, d] = T(e);
  return p(() => {
    d(e);
  }, [e]), {
    handleCurrencyCodeSelected: eo(
      (y) => {
        d(y.data), o && o(y.data, s);
      },
      [o]
    ),
    selectedCurrencyItem: s
  };
}, f = [
  { id: 1, code: "USD", name: "US Dollar", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 8, code: "CAD", name: "Canadian Dollar", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 3, code: "GBP", name: "British Pound", symbol: "£", decodedSymbol: "£", symbolPosition: 0 },
  { id: 2, code: "EUR", name: "Euro", symbol: "€", decodedSymbol: "€", symbolPosition: 0 },
  { id: 22, code: "AED", name: "UAE dirham", symbol: "Dhs", decodedSymbol: "Dhs", symbolPosition: 0 },
  { id: 96, code: "AFN", name: "Afghanistan Afghani", symbol: "؋", decodedSymbol: "؋", symbolPosition: 1 },
  { id: 84, code: "ALL", name: "Albania Lek", symbol: "Lek", decodedSymbol: "Lek", symbolPosition: 0 },
  { id: 130, code: "AMD", name: "Armenian Dram", symbol: "֏", decodedSymbol: "֏", symbolPosition: 0 },
  { id: 35, code: "ANG", name: "Netherlands Antilles Guilder", symbol: "ƒ", decodedSymbol: "ƒ", symbolPosition: 0 },
  { id: 139, code: "AOA", name: "Angolan Kwanza", symbol: "Kz", decodedSymbol: "Kz", symbolPosition: 0 },
  { id: 6, code: "ARS", name: "Argentine Peso", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 7, code: "AUD", name: "Australian Dollar", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 34, code: "AWG", name: "Aruba Guilder", symbol: "ƒ", decodedSymbol: "ƒ", symbolPosition: 0 },
  {
    id: 76,
    code: "AZN",
    name: "Azerbaijan New Manat",
    symbol: "ман",
    decodedSymbol: "ман",
    symbolPosition: 0
  },
  { id: 82, code: "BAM", name: "Bosnia and Herzegovina Convertible Marka", symbol: "KM", decodedSymbol: "KM", symbolPosition: 0 },
  { id: 49, code: "BBD", name: "Barbados Dollar", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 119, code: "BDT", name: "Bangladeshi Taka", symbol: "৳", decodedSymbol: "৳", symbolPosition: 0 },
  { id: 72, code: "BGN", name: "Bulgaria Lev", symbol: "лв", decodedSymbol: "лв", symbolPosition: 0 },
  { id: 126, code: "BHD", name: "Bahraini Dinar", symbol: "BD", decodedSymbol: "BD", symbolPosition: 0 },
  { id: 143, code: "BIF", name: "Burundian Franc", symbol: "FBu", decodedSymbol: "FBu", symbolPosition: 0 },
  { id: 50, code: "BMD", name: "Bermuda Dollar", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 51, code: "BND", name: "Brunei Darussalam Dollar", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 65, code: "BOB", name: "Bolivia Boliviano", symbol: "$b", decodedSymbol: "$b", symbolPosition: 0 },
  { id: 19, code: "BRL", name: "Brazilian Real", symbol: "R$", decodedSymbol: "R$", symbolPosition: 0 },
  { id: 48, code: "BSD", name: "Bahamas Dollar", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 88, code: "BWP", name: "Botswana Pula", symbol: "P", decodedSymbol: "P", symbolPosition: 0 },
  { id: 103, code: "BYN", name: "Belarus Ruble", symbol: "p.", decodedSymbol: "p.", symbolPosition: 0 },
  { id: 68, code: "BZD", name: "Belize Dollar", symbol: "BZ$", decodedSymbol: "BZ$", symbolPosition: 0 },
  { id: 141, code: "CDF", name: "Congolese Francs", symbol: "FC", decodedSymbol: "FC", symbolPosition: 0 },
  { id: 9, code: "CHF", name: "Swiss Franc", symbol: "CHF", decodedSymbol: "CHF", symbolPosition: 0 },
  { id: 53, code: "CLP", name: "Chile Peso", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 18, code: "CNY", name: "Chinese Yuan Renminbi", symbol: "¥", decodedSymbol: "¥", symbolPosition: 0 },
  { id: 54, code: "COP", name: "Colombia Peso", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 36, code: "CRC", name: "Costa Rica Colon", symbol: "₡", decodedSymbol: "₡", symbolPosition: 0 },
  { id: 46, code: "CUP", name: "Cuba Peso", symbol: "₱", decodedSymbol: "₱", symbolPosition: 0 },
  { id: 81, code: "CZK", name: "Czech Republic Koruna", symbol: "Kč", decodedSymbol: "Kč", symbolPosition: 0 },
  { id: 98, code: "DKK", name: "Denmark Krone", symbol: "kr", decodedSymbol: "kr", symbolPosition: 0 },
  { id: 90, code: "DOP", name: "Dominican Republic Peso", symbol: "RD$", decodedSymbol: "RD$", symbolPosition: 0 },
  { id: 142, code: "DZD", name: "Algerian Dinar", symbol: "د.ج", decodedSymbol: "د.ج", symbolPosition: 1 },
  { id: 140, code: "ECS", name: "Ecuadorian Sucres", symbol: "S/.", decodedSymbol: "S/.", symbolPosition: 0 },
  { id: 99, code: "EEK", name: "Estonia Kroon", symbol: "kr", decodedSymbol: "kr", symbolPosition: 0 },
  { id: 105, code: "EGP", name: "Egypt Pound", symbol: "E£", decodedSymbol: "E£", symbolPosition: 0 },
  { id: 123, code: "ETB", name: "Ethiopian Birr", symbol: "Br", decodedSymbol: "Br", symbolPosition: 0 },
  { id: 57, code: "FJD", name: "Fiji Dollar", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 106, code: "FKP", name: "Falkland Islands (Malvinas) Pound", symbol: "£", decodedSymbol: "£", symbolPosition: 0 },
  { id: 134, code: "GEL", name: "Georgian Lari", symbol: "₾", decodedSymbol: "₾", symbolPosition: 0 },
  { id: 108, code: "GGP", name: "Guernsey Pound", symbol: "£", decodedSymbol: "£", symbolPosition: 0 },
  { id: 104, code: "GHC", name: "Ghana Cedis", symbol: "¢", decodedSymbol: "¢", symbolPosition: 0 },
  { id: 21, code: "GHS", name: "Ghanaian Cedi", symbol: "GH₵", decodedSymbol: "GH₵", symbolPosition: 0 },
  { id: 107, code: "GIP", name: "Gibraltar Pound", symbol: "£", decodedSymbol: "£", symbolPosition: 0 },
  { id: 150, code: "GMD", name: "Gambian Dalasi", symbol: "D", decodedSymbol: "D", symbolPosition: 1 },
  { id: 127, code: "GNF", name: "Guinean Franc", symbol: "GNF", decodedSymbol: "GNF", symbolPosition: 0 },
  { id: 89, code: "GTQ", name: "Guatemala Quetzal", symbol: "Q", decodedSymbol: "Q", symbolPosition: 0 },
  { id: 58, code: "GYD", name: "Guyana Dollar", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 10, code: "HKD", name: "Hong Kong Dollar", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 83, code: "HNL", name: "Honduras Lempira", symbol: "L", decodedSymbol: "L", symbolPosition: 0 },
  { id: 97, code: "HRK", name: "Croatia Kuna", symbol: "kn", decodedSymbol: "kn", symbolPosition: 0 },
  { id: 148, code: "HTG", name: "Haitian Gourde", symbol: "G", decodedSymbol: "G", symbolPosition: 0 },
  { id: 78, code: "HUF", name: "Hungary Forint", symbol: "Ft", decodedSymbol: "Ft", symbolPosition: 0 },
  { id: 29, code: "IDR", name: "Indonesian Rupiah", symbol: "Rp", decodedSymbol: "Rp", symbolPosition: 0 },
  { id: 43, code: "ILS", name: "Israel Shekel", symbol: "₪", decodedSymbol: "₪", symbolPosition: 0 },
  { id: 109, code: "IMP", name: "Isle of Man Pound", symbol: "£", decodedSymbol: "£", symbolPosition: 0 },
  { id: 11, code: "INR", name: "Indian Rupee", symbol: "₹", decodedSymbol: "₹", symbolPosition: 0 },
  { id: 135, code: "IQD", name: "Iraqui Dinar", symbol: "د.ع", decodedSymbol: "د.ع", symbolPosition: 1 },
  { id: 114, code: "IRR", name: "Iran Rial", symbol: "﷼", decodedSymbol: "﷼", symbolPosition: 1 },
  { id: 100, code: "ISK", name: "Iceland Krona", symbol: "kr", decodedSymbol: "kr", symbolPosition: 0 },
  { id: 110, code: "JEP", name: "Jersey Pound", symbol: "£", decodedSymbol: "£", symbolPosition: 0 },
  { id: 80, code: "JMD", name: "Jamaica Dollar", symbol: "J$", decodedSymbol: "J$", symbolPosition: 0 },
  { id: 122, code: "JOD", name: "Jordanian Dinar", symbol: "JD", decodedSymbol: "JD", symbolPosition: 0 },
  { id: 4, code: "JPY", name: "Yen", symbol: "¥", decodedSymbol: "¥", symbolPosition: 0 },
  { id: 16, code: "KES", name: "Kenyan Shilling", symbol: "Ksh", decodedSymbol: "Ksh", symbolPosition: 0 },
  { id: 74, code: "KGS", name: "Kyrgyzstan Som", symbol: "лв", decodedSymbol: "лв", symbolPosition: 0 },
  { id: 33, code: "KHR", name: "Cambodia Riel", symbol: "៛", decodedSymbol: "៛", symbolPosition: 0 },
  { id: 42, code: "KPW", name: "Korea (North) Won", symbol: "₩", decodedSymbol: "₩", symbolPosition: 0 },
  { id: 24, code: "KRW", name: "South Korean Won", symbol: "₩", decodedSymbol: "₩", symbolPosition: 0 },
  { id: 118, code: "KWD", name: "Kuwaiti Dinar", symbol: "K.D.", decodedSymbol: "K.D.", symbolPosition: 0 },
  { id: 52, code: "KYD", name: "Cayman Islands Dollar", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 73, code: "KZT", name: "Kazakhstan Tenge", symbol: "₸", decodedSymbol: "â¸", symbolPosition: 0 },
  { id: 44, code: "LAK", name: "Laos Kip", symbol: "₭", decodedSymbol: "₭", symbolPosition: 0 },
  { id: 111, code: "LBP", name: "Lebanon Pound", symbol: "£", decodedSymbol: "£", symbolPosition: 0 },
  { id: 41, code: "LKR", name: "Sri Lanka Rupee", symbol: "₨", decodedSymbol: "₨", symbolPosition: 0 },
  { id: 59, code: "LRD", name: "Liberia Dollar", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 152, code: "LSL", name: "Lesotho Loti", symbol: "M", decodedSymbol: "M", symbolPosition: 0 },
  { id: 86, code: "LTL", name: "Lithuania Litas", symbol: "Lt", decodedSymbol: "Lt", symbolPosition: 0 },
  { id: 85, code: "LVL", name: "Latvia Lat", symbol: "Ls", decodedSymbol: "Ls", symbolPosition: 0 },
  { id: 160, code: "LYD", name: "Libyan Dinar", symbol: "LD", decodedSymbol: "LD", symbolPosition: 0 },
  { id: 121, code: "MAD", name: "Moroccan dirham", symbol: "Dh", decodedSymbol: "Dh", symbolPosition: 0 },
  { id: 153, code: "MDL", name: "Moldovan leu", symbol: "L", decodedSymbol: "L", symbolPosition: 1 },
  { id: 155, code: "MGA", name: "Malagasy Ariary", symbol: "Ar", decodedSymbol: "Ar", symbolPosition: 0 },
  {
    id: 71,
    code: "MKD",
    name: "Macedonia Denar",
    symbol: "ден",
    decodedSymbol: "ден",
    symbolPosition: 0
  },
  { id: 132, code: "MMK", name: "Burmese Kyat", symbol: "K", decodedSymbol: "K", symbolPosition: 0 },
  { id: 45, code: "MNT", name: "Mongolia Tughrik", symbol: "₮", decodedSymbol: "₮", symbolPosition: 0 },
  { id: 31, code: "MOP", name: "Macau Pataca", symbol: "MOP$", decodedSymbol: "MOP$", symbolPosition: 0 },
  { id: 38, code: "MUR", name: "Mauritius Rupee", symbol: "₨", decodedSymbol: "₨", symbolPosition: 0 },
  { id: 133, code: "MVR", name: "Maldivian Rufiyaa", symbol: "Rf", decodedSymbol: "Rf", symbolPosition: 0 },
  { id: 136, code: "MWK", name: "Malawian Kwacha", symbol: "MK", decodedSymbol: "MK", symbolPosition: 0 },
  { id: 30, code: "MXN", name: "Mexican Peso", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 25, code: "MYR", name: "Malaysian ringgit", symbol: "RM", decodedSymbol: "RM", symbolPosition: 0 },
  { id: 87, code: "MZN", name: "Mozambique Metical", symbol: "MT", decodedSymbol: "MT", symbolPosition: 0 },
  { id: 60, code: "NAD", name: "Namibia Dollar", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 20, code: "NGN", name: "Nigerian Naira", symbol: "₦", decodedSymbol: "₦", symbolPosition: 0 },
  { id: 70, code: "NIO", name: "Nicaragua Cordoba", symbol: "C$", decodedSymbol: "C$", symbolPosition: 0 },
  { id: 101, code: "NOK", name: "Norway Krone", symbol: "kr", decodedSymbol: "kr", symbolPosition: 0 },
  { id: 39, code: "NPR", name: "Nepal Rupee", symbol: "₨", decodedSymbol: "₨", symbolPosition: 0 },
  { id: 12, code: "NZD", name: "New Zealand Dollar", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 115, code: "OMR", name: "Oman Rial", symbol: "﷼", decodedSymbol: "﷼", symbolPosition: 1 },
  { id: 67, code: "PAB", name: "Panama Balboa", symbol: "B/.", decodedSymbol: "B/.", symbolPosition: 0 },
  { id: 92, code: "PEN", name: "Peru Nuevo Sol", symbol: "S/.", decodedSymbol: "S/.", symbolPosition: 0 },
  { id: 120, code: "PGK", name: "Papua New Guinean Kina", symbol: "K", decodedSymbol: "K", symbolPosition: 0 },
  { id: 13, code: "PHP", name: "Philippine Peso", symbol: "Php", decodedSymbol: "Php", symbolPosition: 0 },
  { id: 15, code: "PKR", name: "Pakistani Rupee", symbol: "Rs", decodedSymbol: "Rs", symbolPosition: 0 },
  { id: 26, code: "PLN", name: "Polish złoty", symbol: "zł", decodedSymbol: "zł", symbolPosition: 0 },
  { id: 79, code: "PYG", name: "Paraguay Guarani", symbol: "Gs", decodedSymbol: "Gs", symbolPosition: 0 },
  { id: 28, code: "QAR", name: "Qatari Riyal", symbol: "QR", decodedSymbol: "QR", symbolPosition: 0 },
  { id: 102, code: "RON", name: "Romania New Leu", symbol: "lei", decodedSymbol: "lei", symbolPosition: 0 },
  {
    id: 66,
    code: "RSD",
    name: "Serbia Dinar",
    symbol: "Дин.",
    decodedSymbol: "Дин.",
    symbolPosition: 0
  },
  { id: 77, code: "RUB", name: "Russia Ruble", symbol: "₽", decodedSymbol: "₽", symbolPosition: 0 },
  { id: 129, code: "RWF", name: "Rwandan Franc", symbol: "FRw", decodedSymbol: "FRw", symbolPosition: 0 },
  { id: 116, code: "SAR", name: "Saudi Arabia Riyal", symbol: "﷼", decodedSymbol: "﷼", symbolPosition: 1 },
  { id: 61, code: "SBD", name: "Solomon Islands Dollar", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 40, code: "SCR", name: "Seychelles Rupee", symbol: "₨", decodedSymbol: "₨", symbolPosition: 0 },
  { id: 145, code: "SDG", name: "Sudanese Pound", symbol: "£Sd", decodedSymbol: "£sd", symbolPosition: 0 },
  { id: 32, code: "SEK", name: "Swedish Krona", symbol: "kr", decodedSymbol: "kr", symbolPosition: 0 },
  { id: 17, code: "SGD", name: "Singapore Dollar", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 112, code: "SHP", name: "Saint Helena Pound", symbol: "£", decodedSymbol: "£", symbolPosition: 0 },
  { id: 128, code: "SLL", name: "Sierra Leonean Leone", symbol: "Le", decodedSymbol: "Le", symbolPosition: 0 },
  { id: 91, code: "SOS", name: "Somalia Shilling", symbol: "S", decodedSymbol: "S", symbolPosition: 0 },
  { id: 62, code: "SRD", name: "Suriname Dollar", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 56, code: "SVC", name: "El Salvador Colon", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 113, code: "SYP", name: "Syria Pound", symbol: "£", decodedSymbol: "£", symbolPosition: 0 },
  { id: 151, code: "SZL", name: "Swazi Lilangeni", symbol: "E", decodedSymbol: "E", symbolPosition: 0 },
  { id: 23, code: "THB", name: "Thai Baht", symbol: "฿", decodedSymbol: "฿", symbolPosition: 0 },
  { id: 156, code: "TJS", name: "Tajikistani Somoni", symbol: "SM", decodedSymbol: "SM", symbolPosition: 1 },
  { id: 144, code: "TND", name: "Tunisian dinar", symbol: "د.ت", decodedSymbol: "د.ت", symbolPosition: 1 },
  { id: 149, code: "TOP", name: "Tongan pa'anga", symbol: "T$", decodedSymbol: "T$", symbolPosition: 0 },
  { id: 37, code: "TRL", name: "Turkey Lira", symbol: "₤", decodedSymbol: "₤", symbolPosition: 0 },
  { id: 93, code: "TRY", name: "Turkey Lira", symbol: "₺", decodedSymbol: "₺", symbolPosition: 0 },
  { id: 94, code: "TTD", name: "Trinidad and Tobago Dollar", symbol: "TT$", decodedSymbol: "TT$", symbolPosition: 0 },
  { id: 63, code: "TVD", name: "Tuvalu Dollar", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 14, code: "TWD", name: "Taiwan New Dollar", symbol: "NT$", decodedSymbol: "NT$", symbolPosition: 0 },
  { id: 131, code: "TZS", name: "Tanzanian Shilling", symbol: "TZS", decodedSymbol: "TZS", symbolPosition: 0 },
  { id: 47, code: "UAH", name: "Ukraine Hryvna", symbol: "₴", decodedSymbol: "₴", symbolPosition: 0 },
  { id: 125, code: "UGX", name: "Uganda Shilling", symbol: "USh", decodedSymbol: "USh", symbolPosition: 0 },
  { id: 64, code: "UYU", name: "Uruguay Peso", symbol: "$U", decodedSymbol: "$U", symbolPosition: 0 },
  { id: 75, code: "UZS", name: "Uzbekistan Som", symbol: "лв", decodedSymbol: "лв", symbolPosition: 0 },
  { id: 69, code: "VEF", name: "Venezuela Bolivar Fuerte", symbol: "Bs", decodedSymbol: "Bs", symbolPosition: 0 },
  { id: 146, code: "VES", name: "Venezuelan Bolívar Soberano", symbol: "Bs.S.", decodedSymbol: "Bs.S.", symbolPosition: 0 },
  { id: 5, code: "VND", name: "Vietnamese đồng", symbol: "₫", decodedSymbol: "₫", symbolPosition: 0 },
  { id: 147, code: "VUV", name: "Vanuatu Vatu", symbol: "VT", decodedSymbol: "VT", symbolPosition: 1 },
  { id: 154, code: "WST", name: "Samoan tālā", symbol: "WS$", decodedSymbol: "WS$", symbolPosition: 1 },
  { id: 138, code: "XAF", name: "Central African Franc", symbol: "CFA", decodedSymbol: "CFA", symbolPosition: 0 },
  { id: 55, code: "XCD", name: "East Caribbean Dollar", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 124, code: "XOF", name: "West African Franc", symbol: "CFA", decodedSymbol: "CFA", symbolPosition: 0 },
  { id: 999, code: "XXX", name: "USD", symbol: "$", decodedSymbol: "$", symbolPosition: 0 },
  { id: 117, code: "YER", name: "Yemen Rial", symbol: "﷼", decodedSymbol: "﷼", symbolPosition: 1 },
  { id: 27, code: "ZAR", name: "South African Rand", symbol: "R", decodedSymbol: "R", symbolPosition: 0 },
  { id: 137, code: "ZMW", name: "Zambian Kwacha", symbol: "ZK", decodedSymbol: "ZK", symbolPosition: 0 },
  { id: 95, code: "ZWD", name: "Zimbabwe Dollar", symbol: "Z$", decodedSymbol: "Z$", symbolPosition: 0 }
], So = yo()(({ mixins: e, palette: o }, { size: s, status: d, disabled: a }) => {
  const y = (r) => {
    switch (r) {
      case "small":
      case "teenie":
        return "16px";
      case "medium":
        return "24px";
      case "large":
      case "biggie":
        return "32px";
      default:
        return "16px";
    }
  }, c = (r) => {
    switch (r) {
      case "small":
      case "teenie":
        return "30px";
      case "medium":
        return "38px";
      case "large":
      case "biggie":
        return "46px";
      default:
        return "30px";
    }
  };
  return {
    divider: {
      "&&": {
        borderColor: a ? o.gray[400] : e.fieldStatusColor(d, o, o.gray[400]),
        height: y(s)
      }
    },
    menuButton: {
      "&&": {
        "& .MuiButton-root": {
          height: c(s),
          "&:hover": {
            boxShadow: `0 0 0 1px ${e.fieldStatusColor(d, o, o.gray[400])}`
          },
          "&:focus": {
            borderColor: e.fieldStatusColor(d, o, o.primary.light),
            boxShadow: `0 0 0 4px ${e.alpha(e.fieldStatusColor(d, o, o.primary.main), 0.1)}`,
            outlineColor: e.fieldStatusColor(d, o, o.primary.light)
          }
        }
      }
    },
    focusVisible: {
      "&&&": {
        boxShadow: `0 0 0 4px ${e.alpha(e.fieldStatusColor(d, o, o.primary.light), 0.1)}`,
        color: e.fieldStatusColor(d, o, o.primary.main),
        outlineColor: e.fieldStatusColor(d, o, o.primary.light),
        borderColor: e.fieldStatusColor(d, o, o.primary.light)
      }
    }
  };
}), P = (e, o) => e.toString().replace(o, "").replace("B/.", ""), A = (e, o, s) => s === co.PREFIXED ? `${o}${P(e, o)}` : `${P(e, o)}${o}`, Ko = io((e, o) => {
  const {
    afterLabel: s,
    ariaDescribedby: d,
    biId: a,
    containerRef: y,
    disabled: c,
    errorMessage: r,
    id: u,
    label: F,
    labelPlacement: G,
    minValue: N,
    name: t,
    note: k,
    notePlacement: I = "block",
    onBlur: E,
    onChange: n,
    onFocus: H,
    required: w,
    size: D = M.ifFeature("encore", "medium", "small"),
    status: C,
    submitUnmaskedValue: $ = !0,
    value: i = {},
    variant: K,
    viewMode: L = !1,
    warningMessage: Z,
    width: U
  } = e, [R, h] = T((i == null ? void 0 : i.amount) ?? ""), { classes: z } = So({ disabled: c, size: D, status: C }), { isReadable: O } = ao(), { currencyCode: V, currencyItems: b, decimalCharacter: v, normalizeZeros: W, padFractionalZeros: Y, scale: x, thousandsSeparator: J } = mo(no);
  p(() => {
    h((i == null ? void 0 : i.amount) ?? "");
  }, [i.amount]);
  const Q = (m, S) => {
    n == null || n({
      amount: $ ? R : A(P(R, S.symbol), m.symbol, m.symbolPosition),
      currencyCode: m.code
    });
  }, X = f.find((m) => m.code === V) || f[0], j = i != null && i.currencyCode ? b == null ? void 0 : b.find((m) => m.code === (i == null ? void 0 : i.currencyCode)) : void 0, { selectedCurrencyItem: l, handleCurrencyCodeSelected: q } = to(
    j || X,
    Q
  ), _ = ({ maskedValue: m, unmaskedValue: S }) => {
    $ ? (h(S), n == null || n({ amount: S, currencyCode: l.code })) : (h(m), n == null || n({
      amount: A(m, l.symbol, l.symbolPosition),
      currencyCode: l.code
    }));
  }, B = lo(null);
  so(
    o,
    () => ({
      id: u,
      focus: () => {
        var m;
        (m = B.current) == null || m.focus();
      }
    }),
    [u, B]
  );
  const oo = /* @__PURE__ */ g.jsx(
    bo,
    {
      biId: a && `${a}-currency`,
      buttonProps: M.ifFeature("encore", {
        classes: { focusVisible: z.focusVisible }
      }),
      currencyCollection: b && b.length ? b : [l],
      disabled: c,
      name: t && `${t}-currency`,
      onChange: q,
      size: D,
      status: C,
      value: l.code,
      variant: K
    }
  );
  return /* @__PURE__ */ g.jsx(
    ro,
    {
      afterLabel: s,
      ariaDescribedby: d,
      biId: a && `${a}-amount`,
      containerRef: y,
      currencyCode: l.code,
      currencySymbol: l.symbol,
      "data-fabric-component": "CurrencyField",
      disabled: c,
      errorMessage: r,
      id: u,
      label: F,
      labelPlacement: G,
      menuButton: !O && !L && b ? oo : void 0,
      minValue: N,
      name: t && `${t}-amount`,
      normalizeZeros: W,
      note: k,
      notePlacement: I,
      onBlur: E,
      onChange: _,
      onFocus: H,
      padFractionalZeros: Y,
      radix: v || ".",
      ref: B,
      required: w,
      scale: x,
      size: D,
      status: C,
      submitUnmaskedValue: $,
      symbolPosition: l.symbolPosition,
      thousandsSeparator: J,
      value: P(R, l.symbol),
      variant: K,
      viewMode: L,
      warningMessage: Z,
      width: U
    }
  );
});
export {
  Ko as C
};
//# sourceMappingURL=currency-field-DnYDcx0r.mjs.map
